<div
  class="resume-minimal"
  [style.--themeColor]="color"
  [style.font-family]="font"
>
  <div class="header" [ngClass]="{ 'no-image': !data.config.photoUrl }">
    <div class="profile-row">
      <ng-container *ngIf="data?.config?.photoUrl; else showProfile">
        <img [src]="data.config.photoUrl" class="profile-img" crossorigin="anonymous" />

        <div class="name-box mt-3">
          <h1 *ngIf="data?.personal_info?.fullName" class="m-0">
            {{ data.personal_info.fullName }}
          </h1>

          <p *ngIf="data?.targetRole" class="role m-0">
            {{ data.targetRole }}
          </p>

          <div
            class="contact"
            *ngIf="
              data?.personal_info?.email ||
              data?.personal_info?.phone ||
              data?.personal_info?.location ||
              data?.personal_info?.linkedinUrl ||
              data?.personal_info?.githubUrl
            "
          >
            <span *ngIf="data?.personal_info?.email">
              <i class="bi bi-envelope-fill"></i>
              {{ data.personal_info.email }}
            </span>

            <span *ngIf="data?.personal_info?.phone">
              <i class="bi bi-telephone-fill"></i>
              {{ data.personal_info.phone }}
            </span>

            <span *ngIf="data?.personal_info?.location">
              <i class="bi bi-geo-alt-fill"></i>
              {{ data.personal_info.location }}
            </span>

            <span *ngIf="data?.personal_info?.linkedinUrl">
              <i class="bi bi-linkedin"></i>
              {{ data.personal_info.linkedinUrl }}
            </span>

            <span *ngIf="data?.personal_info?.githubUrl">
              <i class="bi bi-github"></i>
              {{ data.personal_info.githubUrl }}
            </span>
          </div>
        </div>
      </ng-container>

      <ng-template #showProfile>
        <div class="name-box">
          <h1 *ngIf="data?.personal_info?.fullName">
            {{ data.personal_info.fullName }}
          </h1>

          <p *ngIf="data?.targetRole" class="role">
            {{ data.targetRole }}
          </p>

          <div
            class="contact"
            *ngIf="
              data?.personal_info?.email ||
              data?.personal_info?.phone ||
              data?.personal_info?.location ||
              data?.personal_info?.linkedinUrl ||
              data?.personal_info?.githubUrl
            "
          >
            <span *ngIf="data?.personal_info?.email">
              <i class="bi bi-envelope-fill"></i>
              {{ data.personal_info.email }}
            </span>

            <span *ngIf="data?.personal_info?.phone">
              <i class="bi bi-telephone-fill"></i>
              {{ data.personal_info.phone }}
            </span>

            <span *ngIf="data?.personal_info?.location">
              <i class="bi bi-geo-alt-fill"></i>
              {{ data.personal_info.location }}
            </span>

            <span *ngIf="data?.personal_info?.linkedinUrl">
              <i class="bi bi-linkedin"></i>
              {{ data.personal_info.linkedinUrl }}
            </span>

            <span *ngIf="data?.personal_info?.githubUrl">
              <i class="bi bi-github"></i>
              {{ data.personal_info.githubUrl }}
            </span>
          </div>
        </div>
      </ng-template>
    </div>
  </div>

  <hr
    *ngIf="
      data?.summary ||
      data?.education?.length ||
      data?.projects?.length ||
      data?.experience?.length
    "
  />

  <div class="section" *ngIf="data?.summary">
    <h3>SUMMARY</h3>
    <p>{{ data.summary }}</p>
  </div>

  <div class="section" *ngIf="data?.education?.length">
    <h3>EDUCATION</h3>

    <ng-container *ngFor="let e of data.education">
      <div class="item" *ngIf="e?.degree || e?.collegeName">
        <div class="row-space">
          <div>
            <b *ngIf="e?.collegeName">{{ e.collegeName }}</b>

            <p class="muted" *ngIf="e?.degree || e?.location">
              <ng-container *ngIf="e?.degree">{{ e.degree }}</ng-container>
              <span *ngIf="e?.degree && e?.location">, </span>
              <ng-container *ngIf="e?.location">{{ e.location }}</ng-container>
            </p>

            <p *ngIf="e?.cgpa_or_percentage">
              CGPA: {{ e.cgpa_or_percentage }}
            </p>
          </div>

          <span *ngIf="e?.startYear || e?.endYear">
            <ng-container *ngIf="e?.startMonth || e?.startYear">
              {{ e.startMonth }} {{ e.startYear }}
            </ng-container>

            <span *ngIf="e?.startYear && e?.endYear"> - </span>

            <ng-container *ngIf="e?.endMonth || e?.endYear">
              {{ e.endMonth }} {{ e.endYear }}
            </ng-container>
          </span>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.projects?.length">
    <h3>PROJECTS</h3>

    <ng-container *ngFor="let p of data.projects">
      <div class="item" *ngIf="p?.title || p?.description">
        <b *ngIf="p?.title">{{ p.title }}</b>

        <p *ngIf="p?.technologies?.length" class="muted">
          {{ p.technologies.join(" • ") }}
        </p>

        <p *ngIf="p?.description">{{ p.description }}</p>

        <p *ngIf="p?.outcome">↗ {{ p.outcome }}</p>
      </div>
    </ng-container>
  </div>

  <div
    class="section"
    *ngIf="
      data?.skills?.technicalSkills?.length ||
      data?.skills?.tools?.length ||
      data?.skills?.softSkills?.length
    "
  >
    <h3>SKILLS</h3>

    <p *ngIf="data?.skills?.technicalSkills?.length">
      <b>Technical:</b> {{ data.skills.technicalSkills.join(" • ") }}
    </p>

    <p *ngIf="data?.skills?.tools?.length">
      <b>Tools:</b> {{ data.skills.tools.join(" • ") }}
    </p>

    <p *ngIf="data?.skills?.softSkills?.length">
      <b>Soft Skills:</b> {{ data.skills.softSkills.join(" • ") }}
    </p>
  </div>

  <div class="section" *ngIf="data?.experience?.length">
    <h3>EXPERIENCE</h3>

    <ng-container *ngFor="let e of data.experience">
      <div class="item" *ngIf="e?.role || e?.company">
        <div class="row-space">
          <b *ngIf="e?.role">{{ e.role }}</b>

          <span *ngIf="e?.startYear || e?.currently_working || e?.endYear">
            <ng-container *ngIf="e?.startMonth || e?.startYear">
              {{ e.startMonth }} {{ e.startYear }}
            </ng-container>

            <span *ngIf="e?.startYear && (e?.endYear || e?.currently_working)">
              -
            </span>

            <ng-container *ngIf="e?.currently_working">Present</ng-container>

            <ng-container *ngIf="!e?.currently_working">
              {{ e.endMonth }} {{ e.endYear }}
            </ng-container>
          </span>
        </div>

        <p *ngIf="e?.company || e?.location">
          {{ e.company }}
          <span *ngIf="e?.company && e?.location">, </span>
          {{ e.location }}
        </p>

        <p *ngIf="e?.description">{{ e.description }}</p>
      </div>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.certifications?.length">
    <h3>CERTIFICATIONS</h3>

    <ng-container *ngFor="let c of data.extras.certifications">
      <p *ngIf="c?.name || c?.platform || c?.year">
        <span *ngIf="c?.name">• {{ c.name }}</span>

        <span *ngIf="c?.platform || c?.year">
          <span *ngIf="c?.name"> - </span>
          {{ c.platform }}
          <span *ngIf="c?.platform && c?.year"> ({{ c.year }})</span>
        </span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.awards?.length">
    <h3>AWARDS</h3>

    <ng-container *ngFor="let a of data.extras.awards">
      <p *ngIf="a?.name">
        • {{ a.name }}
        <span *ngIf="a?.organization">({{ a.organization }})</span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.hackathons?.length">
    <h3>HACKATHONS</h3>

    <ng-container *ngFor="let h of data.extras.hackathons">
      <p *ngIf="h?.name">
        • {{ h.name }}
        <span *ngIf="h?.rank">({{ h.rank }})</span>
      </p>
    </ng-container>
  </div>

  <div class="section" *ngIf="data?.extras?.languages?.length">
    <h3>LANGUAGES</h3>

    <ng-container *ngFor="let l of data.extras.languages">
      <p *ngIf="l?.name">
        • {{ l.name }}
        <span *ngIf="l?.proficiency">({{ l.proficiency }})</span>
      </p>
    </ng-container>
  </div>
</div>
